<template>
  <div class="sidebar-nav-breadcrumb-cpn show-flex-box-r">
    <ul class="show-flex-box-r">
      <li v-for="(item,index) in routeList" :key="index" class="show-flex-box-r">
        <strong v-if="item.meta">{{item.meta.title}}</strong>
        <em>＞</em>
      </li>
    </ul>
  </div>
</template>

<script>

  export default {
    name: "sidebarNavBreadcrumb",
    data() {
      return {
        routeList: []
      };
    },
    components: {},
    mounted() {
      this.getBreadcrumb();
    },
    methods: {
      getBreadcrumb: function() {
        let matched = this.$route.matched;
        this.routeList = matched;
      }
    },
    watch: {
      $route: function() {
        this.getBreadcrumb();
      }
    }
  };

</script>
<style lang="less" scoped>
  .sidebar-nav-breadcrumb-cpn {
    height: 100%;
    justify-content: flex-start;
    align-items: center;
    user-select: none;
    &>ul {
      &>li {
        font-size: 13px;
        color: #837E7E;
        &>strong {
          display: block;
        }
        &>em {
          display: block;
          margin: 0 3px;
        }
      }
      &>li:last-child {
        &>em {
          display: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/my/nav/sidebar_nav_breadcrumb_cpn.vue